import * as Sentry from '@root/vendor/@sentry/react';
import AppEntry from '@root/quote.joinroot.com/src/app-entry';
import CaptchaService from '@root/core/src/services/captcha-service';
import EppoClientService from '@root/core/src/services/eppo-client-service';
import ErrorReportService from '@root/core/src/services/error-report-service';
import React from '@root/vendor/react';
import ReactDOM from '@root/vendor/react-dom';
import environment from '@root/core/src/utils/environment';
import { Integrations } from '@root/vendor/@sentry/tracing';
import { Router } from '@root/vendor/react-router-dom';
import { createBrowserHistory } from '@root/vendor/history';

const UNSUPPORTED_BROWSERS = [
  'Edge/17',
  'Edge/18',
];

const isUnsupportedBrowser = () => {
  for (const browser of UNSUPPORTED_BROWSERS) {
    if (window.navigator.userAgent && window.navigator.userAgent.indexOf(browser) >= 0) {
      return true;
    }
  }

  return false;
};

const loadTrackingIframe = () => {
  const script = document.createElement('script');
  script.src = '/tracking-iframe-javascript.js';
  // The bootstrap only creates the GTM iframe when it can read
  // data-google-tag-manager-enabled === 'true' off its own script element (via
  // document.currentScript, or the #root-tracking-iframe-bootstrap fallback for async
  // injection). This script is injected dynamically, so set both here — otherwise the
  // flag is undefined and GTM never loads. setupTrackingIframe already gates on
  // environment.googleTagManagerEnabled, so reaching here means GTM is enabled.
  script.id = 'root-tracking-iframe-bootstrap';
  script.dataset.googleTagManagerEnabled = 'true';
  document.body.appendChild(script);
};

const setupTrackingIframe = () => {
  if (!environment.googleTagManagerEnabled) {
    return;
  }

  if (typeof window.waitForOsanoToStart === 'function') {
    window.waitForOsanoToStart().then(loadTrackingIframe);
  } else {
    loadTrackingIframe();
  }
};

if (!Object.entries || !window.URLSearchParams || isUnsupportedBrowser()) {
  // eslint-disable-next-line root/prevent-use-of-window-location
  window.location.replace(`${environment.websiteBaseUrl}/app/`);
} else {
  CaptchaService.setup();
  EppoClientService.initialize();
  setupTrackingIframe();

  const history = createBrowserHistory();
  let tracesSampleRate = 1.0;

  if (environment.environment === 'production') {
    tracesSampleRate = 0.05;
  }
  const options = {
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    tracesSampleRate,
  };

  ErrorReportService.init({
    environment,
    options,
  });

  ReactDOM.render(
    <AppEntry
      history={history}
      routerComponent={Router}
    />,
    document.getElementById('root')
  );
}
